import { ProMigrationStatus } from '../admin';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_PRO_MIGRATION_STATUS = 'PRO_MIGRATION_STATUS_';

export const ProMigrationStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_PRO_MIGRATION_STATUS}${ProMigrationStatus.SCHEDULED}`]: 'Programmée',
    [`${TRANSLATE_KEY_PRO_MIGRATION_STATUS}${ProMigrationStatus.DONE}`]: 'Réalisée',
    [`${TRANSLATE_KEY_PRO_MIGRATION_STATUS}${ProMigrationStatus.CANCELLED}`]: 'Annulée',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(ProMigrationStatus, ProMigrationStatusTranslation, TRANSLATE_KEY_PRO_MIGRATION_STATUS, true);
